import React, { useState } from "react";
import { Button, ButtonToolbar, Modal } from "rsuite";
import ModalFooter from "rsuite/esm/Modal/ModalFooter";
import { ProcessesVM } from "../../../Models/ViewModels";
import { BootstrapIcon } from "../../../SharedComponents/BootstrapIcon";
import { AddEditDeleteProcess } from "./AddEditDeleteProcess";

type attributes = {
  action: string;
  data: ProcessesVM;
  onAction: any;
  cachedData: any;
};
export const ProcessModal = (props: attributes) => {
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState();
  const handleOpen = (value: any) => {
    setSize(value);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const onAddProcess = (prrDetail: ProcessesVM) => {
    handleClose();
    props.onAction(prrDetail);
  };
  const onEditProcess = (prrDetail: ProcessesVM) => {
    handleClose();
    props.onAction(prrDetail);
  };
  const onDeleteProcess = (prrDetail: ProcessesVM) => {
    handleClose();
    props.onAction(prrDetail);
  };

  if (props.action === "edit") {
    return (
      <div className="modal-container">
        <i
          className="bi bi-pencil-fill text-warning"
          onClick={() => handleOpen("xs")}
        ></i>
        <Modal size={size} open={open} onClose={handleClose}>
          <AddEditDeleteProcess
            title="Edit Process"
            type={props.action}
            data={props.data}
            cachedData={props.cachedData}
            onAction={onEditProcess}
          />
        </Modal>
      </div>
    );
  } else if (props.action === "add") {
    return (
      <div className="modal-container">
        <ButtonToolbar>
          <Button
            appearance="primary"
            color="green"
            size="md"
            onClick={() => handleOpen("xs")}
          >
            <BootstrapIcon
              bootStrapIconName="plus"
              size={15}
              cssClasses="me-1"
            />
            Add
          </Button>
        </ButtonToolbar>

        <Modal size={size} open={open} onClose={handleClose}>
          <AddEditDeleteProcess
            type="add"
            title="Add New Process"
            data={props.data}
            cachedData={props.cachedData}
            onAction={onAddProcess}
          />
          <ModalFooter></ModalFooter>
        </Modal>
      </div>
    );
  } else {
    return (
      <div className="modal-container">
        <ButtonToolbar>
          <i
            className="bi bi-trash3-fill text-danger"
            onClick={() => handleOpen("xs")}
          ></i>
        </ButtonToolbar>
        <Modal size={size} open={open} onClose={handleClose}>
          <AddEditDeleteProcess
            title="Delete Process"
            type={props.action}
            data={props.data}
            cachedData={props.cachedData}
            onAction={onDeleteProcess}
          />
        </Modal>
      </div>
    );
  }
};
